import classes from './Details.module.sass'
import { StockDocumentInterface } from '../../../../../common/types/interfaces'
import { format } from 'date-fns'

type Props = {
  el?: StockDocumentInterface
}

export const Details = ({ el }: Props) => {
  if (!el) return null

  const getTypeText = (type: number) => {
    switch (type) {
      case 0:
        return 'Приход'
      case 1:
        return 'Списание'
      default:
        return 'Документ'
    }
  }

  const totalItems = el.movements?.reduce((sum, m) => sum + (Number(m.count) || 0), 0) || 0

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>ДЕТАЛИ ДОКУМЕНТА</div>

        <div className={classes.row}>
          <div className={classes.id}>
            <div className={classes.label}>ТИП</div>
            <div className={classes.value}>{getTypeText(el.type)}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>НОМЕР</div>
            <div className={classes.value}>{el.number}</div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>МАГАЗИН</div>
            <div className={classes.value}>{el.store?.name || '---'}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>КОММЕНТАРИЙ</div>
            <div className={classes.value}>{el.comment || ''}</div>
          </div>
        </div>

        <div className={classes.title}>ПОЗИЦИИ</div>

        {el.movements?.map((movement, idx) => (
          <div key={idx} className={classes.row}>
            <div className={classes.name}>
              <div className={classes.label}>НАИМЕНОВАНИЕ</div>
              <div className={classes.itemValue}>{movement.saleItem?.name || `Товар #${movement.saleItemId}`}</div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>КОЛИЧЕСТВО</div>
              <div className={classes.itemValue}>{movement.count} шт</div>
            </div>
          </div>
        ))}

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>ИТОГО ПОЗИЦИЙ</div>
            <div className={classes.value}>{el.movements?.length || 0}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>ИТОГО ШТУК</div>
            <div className={classes.value}>{totalItems} шт</div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>СОЗДАНО</div>
            <div className={classes.value}>{format(new Date(el.createdAt || ''), 'dd.MM.yyyy HH:mm')}</div>
          </div>
          {el.updatedAt && el.updatedAt !== el.createdAt && (
            <div className={classes.item}>
              <div className={classes.label}>ИЗМЕНЕНО</div>
              <div className={classes.value}>{format(new Date(el.updatedAt), 'dd.MM.yyyy HH:mm')}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}